// 报告数据清洗流水线
// 由 store 在请求成功后调用 transformReport(data, showModules)：
//   1. parseBase 负责公共字段的 JSON.parse（多个模块共享的基础反序列化）
//   2. 根据 showModules 只调用需要显示的模块对应的 transform
//
// parseBase 始终执行，因为 tizhi_content 等字段被多个模块共享，
// 由各模块独立 parse 容易出现竞态和重复解析。
import userInfoTransform from './UserInfo/transform';
import tongueTransform from './Tongue/transform';
import faceTransform from './Face/transform';
import innateTransform from './Innate/transform';
import physiqueTransform from './Physique/transform';
import featureTransform from './Feature/transform';
import zangfuTransform from './Zangfu/transform';
import qixuejinyeTransform from './Qixuejinye/transform';
import jingluoTransform from './Jingluo/transform';
import balanceTransform from './Balance/transform';
import tendencyTransform from './Tendency/transform';
import adjustmentTransform from './Adjustment/transform';
import physiqueBusinessTransform from './PhysiqueBusiness/transform';
import wuzangRiskTransform from './WuzangRisk/transform';
import jingluoRiskTransform from './JingluoRisk/transform';
import adjustmentFunTransform from './AdjustmentFun/transform';

export function parseBase(data) {
    if (!data) return;
    if (typeof data.tizhi_content === 'string') {
        data.tizhi_content = JSON.parse(data.tizhi_content);
    }
    if (typeof data.tizhi_jingluo === 'string') {
        data.tizhi_jingluo = JSON.parse(data.tizhi_jingluo);
    }
    if (typeof data.tizhi_jingluo_qingxiang === 'string') {
        data.tizhi_jingluo_qingxiang = JSON.parse(data.tizhi_jingluo_qingxiang);
    }
    if (typeof data.tizhi_qixuejinye === 'string') {
        data.tizhi_qixuejinye = JSON.parse(data.tizhi_qixuejinye);
    }
    if (typeof data.tizhi_zangfu === 'string') {
        data.tizhi_zangfu = data.tizhi_zangfu === '{}' ? '' : JSON.parse(data.tizhi_zangfu);
    }
    if (typeof data.face_text === 'string') {
        data.face_text = JSON.parse(data.face_text);
    }
    if (typeof data.wylq === 'string') {
        data.wylq = JSON.parse(data.wylq);
    }
}

// 每个 transform 声明它服务于哪些模块名（与 helpers.js MODULE_CONFIG 中的名称对应）
// 注意：商业版的 PhysiqueBusiness / WuzangRisk / JingluoRisk 组件各自独立，
// 不依赖政府版的 transform，如需清洗数据应在此新增对应 transform。
const transforms = [
    { fn: userInfoTransform, modules: ['用户的基础信息'] },
    { fn: tongueTransform, modules: ['舌象分析'] },
    { fn: faceTransform, modules: ['面象分析'] },
    { fn: innateTransform, modules: ['先天健康状态'] },
    { fn: physiqueTransform, modules: ['中医体质辨识（政府版）'] },
    { fn: featureTransform, modules: ['体质特征'] },
    { fn: zangfuTransform, modules: ['脏腑辨证'] },
    { fn: qixuejinyeTransform, modules: ['气血津液辨证'] },
    { fn: jingluoTransform, modules: ['经络辨证'] },
    { fn: balanceTransform, modules: ['健康平衡度'] },
    { fn: tendencyTransform, modules: ['发病倾向'] },
    { fn: adjustmentTransform, modules: ['体质调理方案', '调理方法', '体质特征', '发病倾向'] },
    { fn: physiqueBusinessTransform, modules: ['中医体质辨识（商业版）'] },
    { fn: wuzangRiskTransform, modules: ['五脏风险评估'] },
    { fn: jingluoRiskTransform, modules: ['经络风险评估'] },
    { fn: adjustmentFunTransform, modules: ['调理方法'] },
];

/**
 * @param {Object} data - 报告原始数据
 * @param {string[]} [showModules] - 需要显示的模块名数组；不传则执行全部 transform（向后兼容）
 */
export function transformReport(data, showModules) {
    if (!data) return;
    parseBase(data);

    const moduleSet = Array.isArray(showModules) && showModules.length > 0
        ? new Set(showModules)
        : null;

    transforms.forEach(({ fn, modules }) => {
        if (!moduleSet || modules.some(m => moduleSet.has(m))) {
            if (typeof fn === 'function') fn(data);
        }
    });
}

export default transformReport;
